import { render, staticRenderFns } from "./Cashups.vue?vue&type=template&id=0afe724e"
import script from "./Cashups.vue?vue&type=script&lang=js"
export * from "./Cashups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports